var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from "react";
import { ItemCustomizationDialog } from "../itemCustomization";
import { RadixFlyOut } from "../primitives/RadixFlyOut";
import { useCart, useUI } from "../../providers";
import { formatCurrency } from "../utility/formatCurrency";
import "./flyOverCart.css";
import { RadixButton } from "../primitives/RadixButton";
import { OrderSummary } from "../orderSummary";
import { getXplorPayDebitFeeDescriptor } from "../utility/xplorPayDebitFeeDescriptor";
import { CartIcon, DeleteIcon, EditIconCheckbox } from "../icons";
import { RadixLoading } from "../primitives/RadixLoading";
import GoogleAnalytics from "../../analytics/google";
import AnalyticsManager from "../../functions/analytics";
import { formatter } from "../utility/formatter";
var toNumber = function (value) {
    if (value === null || value === undefined || value === "") {
        return 0;
    }
    var numericValue = typeof value === "string" ? Number(value) : value;
    return Number.isNaN(numericValue) ? 0 : numericValue;
};
var getSessionItemNavigations = function () {
    var globalSession = window.session;
    if (!Array.isArray(globalSession === null || globalSession === void 0 ? void 0 : globalSession.item_navigations)) {
        return [];
    }
    return globalSession.item_navigations.filter(function (entry) {
        return Boolean(entry && typeof entry === "object");
    });
};
var findImageFromSessionByItemId = function (itemId) {
    if (typeof itemId === "undefined") {
        return null;
    }
    var match = getSessionItemNavigations().find(function (navigation) {
        return navigation.id === itemId;
    });
    var imageCandidate = match === null || match === void 0 ? void 0 : match.imageURL;
    return typeof imageCandidate === "string" && imageCandidate.trim().length > 0 ? imageCandidate : null;
};
var getLineImageUrl = function (line) {
    return findImageFromSessionByItemId(Number(line.item_navigation_id));
};
var getModifiersByPortion = function (modifiers, portions) {
    if (!Array.isArray(modifiers)) {
        return [];
    }
    return modifiers.filter(function (modifier) {
        if (!modifier || typeof modifier !== "object") {
            return false;
        }
        var quantity = typeof modifier.quantity === "number" ? modifier.quantity : 0;
        return quantity > 0 && Boolean(modifier.portion && portions.includes(modifier.portion));
    });
};
var formatModifiers = function (modifiers) {
    return modifiers
        .map(function (modifier) {
        var name = formatter.removeTrailingAsterisk(modifier.name) || "Modifier";
        var quantity = typeof modifier.quantity === "number" ? modifier.quantity : 0;
        return quantity > 1 ? "".concat(name, " x").concat(quantity) : name;
    })
        .join(", ");
};
var getLineComment = function (comment) {
    return typeof comment === "string" ? comment.trim() : "";
};
var isSpecialDiscountLine = function (line) {
    var categoryId = Number(line.category_id);
    if (Number.isFinite(categoryId) && categoryId === 0) {
        return true;
    }
    var lineType = line.line_type;
    return typeof lineType === "string" && lineType.toLowerCase() === "special_discount";
};
export var FlyOverCart = function () {
    var _a, _b;
    var _c = useUI(), cartIsOpen = _c.cartIsOpen, setCartIsOpen = _c.setCartIsOpen, closeCart = _c.closeCart;
    var _d = useCart(), cart = _d.cart, items = _d.items, removeItem = _d.removeItem, updateItem = _d.updateItem, editingItem = _d.editingItem, stopEditingItem = _d.stopEditingItem;
    var _e = useState(null), removingId = _e[0], setRemovingId = _e[1];
    var _f = useState(null), editingLineId = _f[0], setEditingLineId = _f[1];
    var cartRecord = cart && typeof cart === "object" ? cart : null;
    var sessionStore = (_a = window.session) === null || _a === void 0 ? void 0 : _a.store;
    var cartLines = items.length > 0
        ? items
        : Array.isArray(cartRecord === null || cartRecord === void 0 ? void 0 : cartRecord.lines)
            ? cartRecord.lines
            : Array.isArray(cartRecord === null || cartRecord === void 0 ? void 0 : cartRecord.cart_lines)
                ? cartRecord.cart_lines
                : Array.isArray(cartRecord === null || cartRecord === void 0 ? void 0 : cartRecord.items)
                    ? cartRecord.items
                    : [];
    var itemCount = cartLines.reduce(function (total, line) {
        var quantity = typeof (line === null || line === void 0 ? void 0 : line.quantity) === "number" ? line.quantity : 0;
        return total + quantity;
    }, 0);
    var cartSubtotal = toNumber((_b = cartRecord === null || cartRecord === void 0 ? void 0 : cartRecord.subtotal) !== null && _b !== void 0 ? _b : cartLines.reduce(function (total, line) {
        var lineSubtotal = toNumber(line === null || line === void 0 ? void 0 : line.subtotal);
        var quantity = typeof (line === null || line === void 0 ? void 0 : line.quantity) === "number" ? line.quantity : 0;
        return total + (lineSubtotal * quantity);
    }, 0));
    var isVerticalCheckoutVisible = typeof document !== "undefined" && Boolean(document.getElementById("checkoutReactContainer"));
    var isSpecialsAvailable = typeof document !== "undefined" && Boolean(document.getElementById("specialReactContainer"));
    var shouldShowMobileCta = itemCount > 0 && !cartIsOpen && !isVerticalCheckoutVisible && !isSpecialsAvailable;
    useEffect(function () {
        var bodyElement = document.body;
        if (!bodyElement) {
            return;
        }
        if (shouldShowMobileCta) {
            bodyElement.classList.add("flyover-cart-mobile-cta-visible");
        }
        else {
            bodyElement.classList.remove("flyover-cart-mobile-cta-visible");
        }
        return function () {
            bodyElement.classList.remove("flyover-cart-mobile-cta-visible");
        };
    }, [shouldShowMobileCta]);
    useEffect(function () {
        if (!cartIsOpen) {
            return;
        }
        AnalyticsManager.reviewCart(cartLines, "cart", function () {
            GoogleAnalytics.viewCart();
        });
    }, [cartIsOpen]);
    var handleRemoveItem = function (lineId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (typeof lineId === "undefined" || lineId === null) {
                        return [2 /*return*/];
                    }
                    setRemovingId(lineId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, removeItem(lineId)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    setRemovingId(null);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(React.Fragment, null,
        React.createElement(RadixFlyOut, { open: cartIsOpen, onOpenChange: setCartIsOpen, title: "Your cart", description: itemCount > 0 ? "".concat(itemCount, " item").concat(itemCount === 1 ? "" : "s") : undefined, closeLabel: "Close cart" },
            React.createElement("div", { className: "flyover-cart-panel" }, cartLines.length === 0 ? (React.createElement("div", { className: "flyover-cart-empty", role: "status", "aria-live": "polite" }, "You have no items in your cart.")) : (React.createElement("div", { className: "flyover-cart-shell" },
                React.createElement("div", { className: "flyover-cart-items", "aria-label": "Cart items" },
                    React.createElement("ul", { className: "flyover-cart-list" }, cartLines.map(function (line, index) {
                        var _a, _b;
                        var name = line.friendly_name || line.name || "Menu item";
                        var quantity = typeof line.quantity === "number" ? line.quantity : 0;
                        var lineTotal = toNumber((_a = (line.subtotal * line.quantity)) !== null && _a !== void 0 ? _a : 0);
                        var key = (_b = line.id) !== null && _b !== void 0 ? _b : "".concat(name, "-").concat(index);
                        var imageUrl = getLineImageUrl(line);
                        var isDeleting = removingId === line.id;
                        var wholeMods = getModifiersByPortion(line.modifications, ["whole"]);
                        var firstHalfMods = getModifiersByPortion(line.modifications, ["first-half"]);
                        var secondHalfMods = getModifiersByPortion(line.modifications, ["second-half"]);
                        var lineComment = getLineComment(line.comment);
                        return (React.createElement("li", { key: key, className: "flyover-cart-line" },
                            React.createElement("div", { className: "flyover-cart-line-main" },
                                React.createElement("div", { className: "flyover-cart-line-media" }, imageUrl ? (React.createElement("img", { src: imageUrl, alt: name, className: "flyover-cart-line-image", loading: "lazy" })) : (React.createElement("div", { className: "flyover-cart-line-placeholder", "aria-label": "No image available" }, "No image"))),
                                React.createElement("div", { className: "flyover-cart-line-details" },
                                    React.createElement("p", { className: "flyover-cart-line-name" }, name),
                                    React.createElement("p", { className: "flyover-cart-line-qty" },
                                        "Qty: ",
                                        quantity),
                                    (wholeMods.length > 0 || firstHalfMods.length > 0 || secondHalfMods.length > 0) && (React.createElement("div", { className: "flyover-cart-line-mods" },
                                        wholeMods.length > 0 && (React.createElement("p", { className: "flyover-cart-line-mods-row" },
                                            React.createElement("strong", null, "Whole:"),
                                            " ",
                                            formatModifiers(wholeMods))),
                                        firstHalfMods.length > 0 && (React.createElement("p", { className: "flyover-cart-line-mods-row" },
                                            React.createElement("strong", null, "First Half:"),
                                            " ",
                                            formatModifiers(firstHalfMods))),
                                        secondHalfMods.length > 0 && (React.createElement("p", { className: "flyover-cart-line-mods-row" },
                                            React.createElement("strong", null, "Second Half:"),
                                            " ",
                                            formatModifiers(secondHalfMods))))),
                                    lineComment ? React.createElement("p", { className: "flyover-cart-line-comment" },
                                        React.createElement("strong", null, "Note:"),
                                        " ",
                                        lineComment) : null,
                                    React.createElement("div", { className: "flyover-cart-line-actions" },
                                        !(Boolean(line.addon_id) || Boolean(Number(line.is_addon || 0)) || isSpecialDiscountLine(line)) ? (React.createElement(RadixButton, { className: "flyover-cart-line-action", "aria-label": "Edit ".concat(name), disabled: editingLineId !== null, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                                return __generator(this, function (_a) {
                                                    switch (_a.label) {
                                                        case 0:
                                                            if (typeof line.id === "undefined" || line.id === null) {
                                                                return [2 /*return*/];
                                                            }
                                                            setEditingLineId(line.id);
                                                            window.editLineComment = getLineComment(line.comment);
                                                            _a.label = 1;
                                                        case 1:
                                                            _a.trys.push([1, , 3, 4]);
                                                            closeCart();
                                                            return [4 /*yield*/, updateItem(line.id, line.category_id)];
                                                        case 2:
                                                            _a.sent();
                                                            return [3 /*break*/, 4];
                                                        case 3:
                                                            setEditingLineId(null);
                                                            return [7 /*endfinally*/];
                                                        case 4: return [2 /*return*/];
                                                    }
                                                });
                                            }); } },
                                            React.createElement(EditIconCheckbox, null))) : null,
                                        React.createElement(RadixButton, { type: "button", className: "flyover-cart-line-action", "aria-label": "Delete ".concat(name), onClick: function () {
                                                handleRemoveItem(line.id);
                                            }, disabled: typeof line.id === "undefined" || isDeleting },
                                            React.createElement(DeleteIcon, null))))),
                            React.createElement("p", { className: "flyover-cart-line-total" }, formatCurrency(lineTotal))));
                    }))),
                React.createElement("footer", { className: "flyover-cart-footer" },
                    React.createElement(OrderSummary, { showFeeVerbiage: false, ncaFeeDescription: getXplorPayDebitFeeDescriptor(sessionStore === null || sessionStore === void 0 ? void 0 : sessionStore.credit_processor, sessionStore === null || sessionStore === void 0 ? void 0 : sessionStore.nca_title) }),
                    React.createElement(RadixButton, { className: "flyover-cart-checkout", onClick: function () {
                            setCartIsOpen(false);
                            window.location.assign("".concat(window.relativeURI(), "/cart"));
                        } }, "Checkout")))))),
        editingLineId !== null ? (React.createElement(RadixLoading, { fullScreen: true, label: "Loading item customization" })) : null,
        React.createElement(ItemCustomizationDialog, { open: Boolean(editingItem), onOpenChange: function (open) {
                if (!open) {
                    stopEditingItem();
                }
            }, itemUrl: (editingItem === null || editingItem === void 0 ? void 0 : editingItem.itemUrl) || null, title: (editingItem === null || editingItem === void 0 ? void 0 : editingItem.title) || "Customize item", editMode: Boolean(editingItem), initialChoices: (editingItem === null || editingItem === void 0 ? void 0 : editingItem.choices) || null, initialItemPayload: (editingItem === null || editingItem === void 0 ? void 0 : editingItem.initialItemPayload) || null, initialQuantity: (editingItem === null || editingItem === void 0 ? void 0 : editingItem.quantity) || null }),
        shouldShowMobileCta ? (React.createElement("button", { type: "button", className: "flyover-cart-mobile-cta", onClick: function () { return setCartIsOpen(true); }, "aria-label": "View order. ".concat(formatCurrency(cartSubtotal), " subtotal with ").concat(itemCount, " item").concat(itemCount === 1 ? "" : "s", ".") },
            React.createElement("span", { className: "flyover-cart-mobile-cta-label" },
                "View order \u2014 ",
                formatCurrency(cartSubtotal)),
            React.createElement("span", { className: "flyover-cart-mobile-cta-count", "aria-hidden": "true" },
                React.createElement(CartIcon, null),
                itemCount))) : null));
};
